import React, { useState } from 'react';

import { Flex, Popover, PopoverAnchor, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { isEmpty } from 'lodash';

import { Calendar } from 'assets/assetsV1/iconComponents';

import { convertDateToString11, convertDateToString12 } from 'constants/helper';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { DateRangePicker } from './index';

const formattedDateRange = (dateRange) => {
  if (dateRange.label) return dateRange.label;

  if (dateRange?.startDate) {
    return `${convertDateToString11(dateRange?.startDate)} to ${convertDateToString11(dateRange?.endDate)}`;
  }
  return 'All';
};

export const formattedDateRangeShort = (dateRange) => {
  if (dateRange.label) return dateRange.label;

  if (dateRange?.startDate) {
    return `${convertDateToString12(dateRange?.startDate)} - ${convertDateToString12(dateRange?.endDate)}`;
  }
  return 'All';
};

export const isEmptyDateRangeValues = (dateRange) => {
  if (dateRange?.startDate && dateRange?.endDate) {
    return false;
  }
  return true;
};

const DateRangeSelectDashed = ({
  onChange = () => {},
  initialDateRange = {},
  minDate,
  maxDate,
  definedRanges,
  placeholderText = 'Select Date Range',
  onClose = () => {},
  onClear = () => {},
  onSelect = () => {},
  showPredefinedRanges = false,
  getTimestamp = false,
  enableEmptyDateRangeToBeSelected = false,
  displayTwoMonthsLayout = true,
  displayCancelButton = true,
  displayClearButton = true,
  placement = 'right',
  width = '280px',
  isPortalContent = true,
}) => {
  // const [isOpen, setIsOpen] = useBoolean();
  const [currentDateRange, setCurrentDateRange] = useState({});
  const [dateRange, setDateRange] = useState({ ...initialDateRange });

  const getPopoverContent = ({ isOpen, onPopoverClose }) => (
    <PopoverContent sx={{ width: '100%' }} rootProps={{ zIndex: 2000 }}>
      <DateRangePicker
        open={isOpen}
        onClose={() => {
          onClose();
          onPopoverClose();
        }}
        onChange={(dateRange) => {
          onChange(dateRange);
          setCurrentDateRange(dateRange);
        }}
        initialDateRange={dateRange}
        minDate={minDate}
        maxDate={maxDate}
        definedRanges={definedRanges}
        placeholderText={placeholderText}
        onClear={() => {
          if (enableEmptyDateRangeToBeSelected) {
            setCurrentDateRange({});
          }
          onClear();
          setDateRange({ startDate: null, endDate: null });

          onClose();
          onPopoverClose();
        }}
        onSelect={() => {
          const dateTS = {
            startDate: currentDateRange?.startDate?.valueOf(),
            endDate: currentDateRange?.endDate?.valueOf(),
            label: currentDateRange?.label,
          };
          setDateRange(currentDateRange);
          if (getTimestamp) {
            onSelect(dateTS);
          } else {
            onSelect(currentDateRange);
          }
          onPopoverClose();
        }}
        showPredefinedRanges={showPredefinedRanges}
        enableEmptyDateRangeToBeSelected={enableEmptyDateRangeToBeSelected}
        displayTwoMonthsLayout={displayTwoMonthsLayout}
        displayCancelButton={displayCancelButton}
        displayClearButton={displayClearButton}
      />
    </PopoverContent>
  );

  return (
    <Popover preventOverflow isLazy placement={placement} closeOnBlur>
      {({ isOpen, onClose: onPopoverClose }) => (
        <>
          <PopoverAnchor>
            <PopoverTrigger>
              <Flex
                alignItems="center"
                cursor="pointer"
                py="10px"
                style={{ borderBottom: '1px dashed #999999' }}
                w={width}
                justifyContent="space-between"
                sx={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <TextBodyMedium
                  mr={2}
                  pr={8}
                  color={isEmpty(dateRange) || isEmptyDateRangeValues(dateRange) ? 'text.g3' : 'text.g1'}
                >
                  {isEmpty(dateRange) || isEmptyDateRangeValues(dateRange)
                    ? placeholderText
                    : formattedDateRange(dateRange)}
                </TextBodyMedium>
                <Calendar boxSize="18px" color="icon.g2" mr={2} />
              </Flex>
            </PopoverTrigger>
          </PopoverAnchor>
          {isPortalContent ? (
            <Portal>{getPopoverContent({ isOpen, onPopoverClose })}</Portal>
          ) : (
            getPopoverContent({ isOpen, onPopoverClose })
          )}
        </>
      )}
    </Popover>
  );
};

export { DateRangeSelectDashed };
